import { orderBy } from 'lodash';
import { INPUT_CROP_METRICS, INPUT_METRICS } from '../constants/inputMetrics';
import { getItemColor } from './colors';
import { getRelativeYearIndex } from './farmData';
import {
  getMetricsForYear,
  getYearlyMetrics,
  YEARLY_METRIC_SUFFIX,
} from './columns';
import { getFilterCropAggregate } from './transforms';

// select just metrics that are arrays "ByYear"
const yearlyMetrics = (allCrops) =>
  getYearlyMetrics(allCrops ? INPUT_METRICS : INPUT_CROP_METRICS);

// transform all metrics to be relevant to a single year
// including replacing any "ByYear" metrics with a single-year metric
export const metricsForYear = (allCrops) =>
  getMetricsForYear(allCrops ? INPUT_METRICS : INPUT_CROP_METRICS);

/*
 * filter the raw data from the API based on the year and crop selected
 * returning a list of inputs and their metrics
 * optionally provide a start year to ensure relative farm year indices are
 * consistent
 */
export const getInputsForYear = (yearIndex, cropFilter, startYear = null) => (
  data,
) => {
  // select either the aggregate (top level) inputs
  // or the per-crop aggregate inputs
  const filterCropAggregate = getFilterCropAggregate(data, cropFilter);
  const baseData = filterCropAggregate || data;
  if (!baseData) return [];
  const allYearlyMetrics = yearlyMetrics(!filterCropAggregate);
  const relativeYearIndex = getRelativeYearIndex(
    yearIndex,
    startYear,
    data.startYear,
  );
  // for each input, augment with colors and metrics
  const augmentedInputs = baseData.inputAggregates.map(
    (inputAggregate, index) => ({
      year: startYear + parseInt(relativeYearIndex, 10),
      ...inputAggregate,
      ...inputAggregate.input,
      id: `${inputAggregate.input.id}-${relativeYearIndex}`,
      // Add displayCost for use with ItemsChart
      displayCost: inputAggregate.totalCostByYear[relativeYearIndex],
      color: getItemColor(inputAggregate.input, index),
      // create a key per metric on this input
      ...allYearlyMetrics.reduce(
        (result, { accessor }) =>
          Object.assign(result, {
            // for all ByYear metrics, selects just the relevant year from the input's value
            [accessor.replace(YEARLY_METRIC_SUFFIX, '')]: inputAggregate[
              accessor
            ][relativeYearIndex],
          }),
        {},
      ),
    }),
  );
  return orderBy(
    augmentedInputs.filter(({ purchaseQuantity }) => purchaseQuantity > 0),
    'displayCost',
    'desc',
  );
};
